import React from 'react'
import { useField } from 'formik'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  makeStyles,
} from '@material-ui/core'
import { Rating } from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
  rating: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    padding: '27px 12px 10px',
  },
}))

const FormikRating = ({ fullWidth, label, margin, variant, ...props }) => {
  const classes = useStyles()
  const [field, meta] = useField(props)
  const { touched, error } = meta
  const hasError = Boolean(touched && error)
  const { value } = field

  return (
    <FormControl
      error={hasError}
      fullWidth={fullWidth}
      margin={margin}
      variant={variant}
    >
      <InputLabel shrink>{label}</InputLabel>
      <div className={classes.rating}>
        <Rating {...field} {...props} value={Number(value)} />
      </div>
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}

FormikRating.defaultProps = {
  variant: 'filled',
}

export default FormikRating
